import styled from 'styled-components';
import { _ as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import { T as Typography, g as getFontStyle } from './index-ae4b14fb.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * SmallText.
 *
 */

var SmallText = styled(Typography)(_templateObject(), getFontStyle('smallText')); // @component

export { SmallText as S };
